import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ssApiService } from 'app/services/ss-api.service';
import { GlobalServices } from './global.service';


@Injectable()
export class AuthGuardService implements CanActivate {


    constructor( private router: Router, private api: ssApiService, private gb: GlobalServices ) {  }


    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        this.gb.ReadFromStorage();
        if ( this.gb.Token != undefined && this.gb.Token != '' && this.gb.TokenExpiration != undefined && this.gb.TokenExpiration > new Date() ) {
            return true;
        } else {
            localStorage.setItem('loginRedirect', state.url);
            this.router.navigate(['/authentication/signin']);
        }

    }

}
